import { IonContent } from '@ionic/react';
import React from 'react';

import { useAppModals } from '@/hooks/useAppModals';
import { CoinsPaymentModal } from '@/modals/CoinsPayment';
import { CoinsUpsaleModal } from '@/modals/CoinsUpsale';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';

import { Content } from '../Default/components/Content';
import { MainImage } from '../Default/components/MainImage';
import { Title } from '../Default/components/Title';

import { PageStyles } from './Default.styles';

const DefaultUpsaleVariant: React.FC = () => {
  const { show, hide, isVisible } = useAppModals('upsale');

  React.useEffect(() => {
    if (!isVisible) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Succesful_payment',
      });
    }
  }, [isVisible]);

  React.useEffect(() => {
    show();
  }, [show]);

  return (
    <PageStyles background={webCampaign.getStaticTheme()}>
      <IonContent>
        <Title />

        <MainImage />

        <Content />
      </IonContent>

      {isVisible && <CoinsUpsaleModal onClose={hide} />}
      <CoinsPaymentModal />
    </PageStyles>
  );
};

export default DefaultUpsaleVariant;
